var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8898 0.0142059C35.0317 0.0142059 44.8872 11.3883 44.8872 25.3936V30.7398C44.8872 33.6521 42.8394 36.0142 40.3146 36.0142H5.45985C2.93504 36.0142 0.887207 33.6521 0.887207 30.7398V25.3936C0.887207 11.3883 10.7479 0.0142059 22.8898 0.0142059Z",
    fill: "url(#paint0_linear_66_2125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0237 14.1032C35.3687 8.82284 29.6244 3.96703 22.8691 3.96703C16.1138 3.96703 10.3695 8.81686 6.7145 14.1032C1.71674 21.3152 6.37233 26.5777 10.2243 26.5777H35.519C39.371 26.5777 44.0266 21.3152 39.0289 14.1032H39.0237Z",
    fill: "url(#paint1_linear_66_2125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8224 20.7515C17.337 20.7515 18.5649 19.0089 18.5649 16.8593C18.5649 14.7096 17.337 12.967 15.8224 12.967C14.3077 12.967 13.0798 14.7096 13.0798 16.8593C13.0798 19.0089 14.3077 20.7515 15.8224 20.7515Z",
    fill: "#60C2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 16.8593C32.6999 14.7094 31.4712 12.967 29.9574 12.967C28.4435 12.967 27.2148 14.7094 27.2148 16.8593C27.2148 19.0091 28.4435 20.7515 29.9574 20.7515C31.4712 20.7515 32.6999 19.0091 32.6999 16.8593Z",
    fill: "#60C2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7187 29.1909H32.0455C33.212 29.1909 34.1556 30.2793 34.1556 31.6248V35.8647H11.6086V31.6248C11.6086 30.2793 12.5522 29.1909 13.7187 29.1909Z",
    fill: "url(#paint2_linear_66_2125)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_2125",
    x1: 0.887207,
    y1: 18.0142,
    x2: 44.8872,
    y2: 18.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_2125",
    x1: 4.53705,
    y1: 15.2694,
    x2: 41.2011,
    y2: 15.2694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_2125",
    x1: 16.1087,
    y1: 25.4235,
    x2: 31.5826,
    y2: 38.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E6E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE8E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_2125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36,
    fill: "white",
    transform: "translate(0.887207 0.0142059)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaIcon);
export default __webpack_public_path__ + "static/media/ia_icon.95898b0f358fd5c8edb97ee80cef48c8.svg";
export { ForwardRef as ReactComponent };